import styled from 'styled-components'

const Style = {
	WrapperDiv: styled.main`
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	`,
	Title: styled.h1`
		${({theme}) => theme.font.large_bold};
	`,
	Content: styled.p`
		${({theme}) => theme.font.small};
		margin-top: 8px;
	`,
	CautionSvg: styled.img`
		width: 560px;
	`,
}
export default Style
